// ============================================================================
// Auth view — sign in / sign up against the shared Supabase auth (auth.users).
// On success the shell calls ensure_profile() to create the hanja profile row.
// ============================================================================

import { el, toast } from '../dom.js';
import * as api from '@core/data/api.js';

export function renderAuth({ onDone }) {
  let mode = 'signin'; // 'signin' | 'signup'
  const wrap = el('div.container');

  function paint() {
    const email = el('input.input', { type: 'email', autocomplete: 'email', placeholder: 'you@example.com' });
    const password = el('input.input', { type: 'password', autocomplete: 'current-password', placeholder: '••••••••' });

    const submit = el('button.btn.btn--primary.btn--block', {
      text: mode === 'signin' ? 'Sign in' : 'Create account',
      onclick: async () => {
        submit.disabled = true;
        try {
          if (mode === 'signin') {
            await api.signIn(email.value.trim(), password.value);
          } else {
            await api.signUp(email.value.trim(), password.value);
            toast('Account created. Check your email if confirmation is required.', 'success');
          }
          onDone?.();
        } catch (e) {
          toast(e.message || 'Authentication failed', 'error');
        } finally {
          submit.disabled = false;
        }
      },
    });

    const toggle = el('button.link-btn', {
      text: mode === 'signin' ? 'New here? Create an account' : 'Have an account? Sign in',
      onclick: () => { mode = mode === 'signin' ? 'signup' : 'signin'; paint(); },
    });

    const form = el('form.card.auth-wrap.stack', {
      onsubmit: (e) => { e.preventDefault(); submit.click(); },
    }, [
      el('h1.center', { html: 'Korean <span class="han" style="color:var(--accent)">漢字</span> Hanja' }),
      el('p.center.muted', { text: 'Learn the characters behind Korean vocabulary.' }),
      el('div.field', {}, [el('label', { text: 'Email' }), email]),
      el('div.field', {}, [el('label', { text: 'Password' }), password]),
      submit,
      el('div.center', {}, [toggle]),
    ]);

    wrap.replaceChildren(form);
    email.focus();
  }

  paint();
  return wrap;
}
